import { z } from 'zod';
import { requiredFieldSchema } from './fields';

export const postMaintenanceTypeSchema = (t) =>
  z.object({
    name: requiredFieldSchema(t('error.maintenanceTypeNameRequired')),
    description: requiredFieldSchema(t('error.maintenanceTypeDescrRequired')),
  });
